import { render, staticRenderFns } from "./upload-purchase-xml-side-action.vue?vue&type=template&id=01f648fb"
import script from "./upload-purchase-xml-side-action.ts?vue&type=script&lang=js&external"
export * from "./upload-purchase-xml-side-action.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports